import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "@/providers/auth-provider";
import { PageSpinner } from "./page-spinner";

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <PageSpinner />;

  if (!isAuthenticated) {
    // Remember where the user was heading so login can send them back.
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }

  return <Outlet />;
}
